import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/pages/Login.vue"),
  },
  {
    path: "/download",
    name: "download",
    component: () => import("@/pages/Download.vue"),
  },
  // {
  //   path: "/loading",
  //   name: "loading",
  //   component: () => import("@/pages/Loading.vue"),
  // },
  // {
  //   path: "/certificateLoading",
  //   name: "certificateLoading",
  //   component: () => import("@/pages/CertificateLoading.vue"),
  // },
  // {
  //   path: "/empty",
  //   name: "empty",
  //   component: () => import("@/pages/Empty.vue"),
  // },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  console.log(to.path);

  if (to.path === "/home") {
    next();
  }

  if (to.path !== "/download") {
    next("/home");
  } else {
    next();
  }
});
export default router;
